// ========================================
// 定数定義
// ========================================
const BREAKPOINTS = {
	SP: 559,
	TABLET: 959
};

const SCROLL_SPEED = 1200;
const SCROLL_EASING = 'easeInOutQuad';

// ========================================
// ユーティリティ
// ========================================

function getSystemInfo() {
	const ua = navigator.userAgent.toLowerCase();
	let browserClass = '';
	let osClass = '';

	if (ua.indexOf('edge') !== -1 || ua.indexOf('edg') !== -1) {
		browserClass = 'browser-edge';
	} else if (ua.indexOf('opera') !== -1 || ua.indexOf('opr') !== -1) {
		browserClass = 'browser-opera';
	} else if (ua.indexOf('chrome') !== -1) {
		browserClass = 'browser-chrome';
	} else if (ua.indexOf('safari') !== -1) {
		browserClass = 'browser-safari';
	} else if (ua.indexOf('firefox') !== -1) {
		browserClass = 'browser-firefox';
	} else if (ua.indexOf('msie') !== -1 || ua.indexOf('trident') !== -1) {
		browserClass = 'browser-ie';
	}

	if (ua.indexOf('windows') !== -1) {
		osClass = 'os-windows';
	} else if (ua.indexOf('mac os x') !== -1) {
		osClass = 'os-mac';
	} else if (ua.indexOf('iphone') !== -1 || ua.indexOf('ipad') !== -1 || ua.indexOf('ipod') !== -1) {
		osClass = 'os-ios';
	} else if (ua.indexOf('android') !== -1) {
		osClass = 'os-android';
	} else if (ua.indexOf('linux') !== -1) {
		osClass = 'os-linux';
	}

	return { browser: browserClass, os: osClass };
}

function deviceSizeFunc(callback) {
	const w = $(window).width();
	if (w <= BREAKPOINTS.SP) {
		if (typeof callback.sp === 'function') callback.sp();
	} else if (w <= BREAKPOINTS.TABLET) {
		if (typeof callback.tablet === 'function') callback.tablet();
	} else {
		if (typeof callback.pc === 'function') callback.pc();
	}
	if (w > BREAKPOINTS.SP) {
		if (typeof callback.overSp === 'function') callback.overSp();
	}
}

// スマートフォン表示の処理
function handleSmartphoneView() {
	/*$(".tel-number").each(function(){
		if(!$(this).parent(".tel-wrap").length){
			const no = $(this).data("tel").replace(/-/g,"");
			$(this).wrap('<a href="tel:' + no + '" class="tel-wrap"></a>');
		}
	});*/
}

// スマートフォンより大きい画面の処理
function handleOverSmartphoneView() {
	$(".tel-wrap .tel-number").each(function() {
		$(this).unwrap();
	});
}

// ========================================
// 初期化関数（init*）
// ========================================

// メニュー機能の初期化
function initMenu() {
	$("#menu-btn").on("click", function() {
		$("body").toggleClass("menu-open");
	});
	$(".gnavi-list a").on("click", function() {
		if ($(window).width() <= BREAKPOINTS.TABLET) {
			$("body").removeClass("menu-open");
		}
	});
}

// キービジュアルスライダー（Swiper）
function initKeySlider() {
	if (typeof Swiper === 'undefined' || !$('.key-slider').length) return;
	new Swiper('.key-slider', {
		loop: true,
		slidesPerView: 'auto',
		centeredSlides: true,
		speed: 1500,
		spaceBetween: 0,
		allowTouchMove: false,
		autoplay: { delay: 3000, disableOnInteraction: false },
		pagination: false,
	});
}

// 画像スライダー（Swiper 無限ループ）
function initImageSlider() {
	if (typeof Swiper === 'undefined' || !$('.image-slider').length) return;
	new Swiper('.image-slider', {
		loop: true,
		speed: 5000,
		slidesPerView: 'auto',
		spaceBetween: 0,
		autoplay: { delay: 0, disableOnInteraction: true },
		grabCursor: false,
		allowTouchMove: false,
	});
}

// スクロールフェードイン（Intersection Observer）
function initScrollFadeIn() {
	const $fadeInEls = $('.js-scroll-fadein');
	if (!$fadeInEls.length) return;
	const observer = new IntersectionObserver(function(entries) {
		$(entries).each(function(index, entry) {
			if (entry.isIntersecting) $(entry.target).addClass('is-visible');
		});
	}, { root: null, rootMargin: '0px 0px -20% 0px', threshold: 0 });
	$fadeInEls.each(function() { observer.observe(this); });
}

// グローバルナビ：スクロール位置に応じて .gnavi-item に .active を付与
function initGnaviScrollSpy() {
	const $items = $('.gnavi-item');
	if (!$items.length) return;
	const links = $items.find('a[href^="#"]').map(function() {
		const href = $(this).attr('href');
		const id = href === '#' || href === '' ? 'wrapper' : href.slice(1);
		return { item: $(this).closest('.gnavi-item'), id: id };
	}).get();
	const $sections = $(links.map(function(l) { return '#' + l.id; }).join(','));
	if (!$sections.length) return;

	let ticking = false;
	function updateActive() {
		const scrollTop = $(window).scrollTop();
		const windowHeight = $(window).height();
		const docHeight = $(document).height();
		const viewportHalf = windowHeight * 0.4;
		let currentId = 'wrapper';
		if (scrollTop + windowHeight >= docHeight - 1) {
			currentId = 'top-contact';
		} else {
			$sections.each(function() {
				const $el = $(this);
				if (scrollTop >= $el.offset().top - viewportHalf) {
					currentId = $el.attr('id') || 'wrapper';
				}
			});
		}
		links.forEach(function(link) {
			link.item.toggleClass('active', link.id === currentId);
		});
		ticking = false;
	}
	$(window).on('scroll', function() {
		if (!ticking) {
			requestAnimationFrame(updateActive);
			ticking = true;
		}
	});
	updateActive();
}

// ニュース一覧：Load More（index_2.html, index_3.html... を順に読み込み）
function initNewsLoadMore() {
	if (!$('#news.bn-index').length) return;
	const $btnLoad = $('.btn-load');
	const $newsList = $('#news-list .news-list');
	if (!$btnLoad.length || !$newsList.length) return;

	let nextPageNumber = 2;
	const staggerDelay = 80;

	function fadeInItems($items) {
		$items.each(function(i) {
			const $el = $(this);
			setTimeout(function() { $el.addClass('is-visible'); }, i * staggerDelay);
		});
	}

	function getNextPageUrl() {
		return 'index_' + nextPageNumber + '.html';
	}

	$btnLoad.on('click', function() {
		const url = getNextPageUrl();
		const urlOneAhead = 'index_' + (nextPageNumber + 1) + '.html';
		const $btn = $(this);
		$btn.addClass('is-loading').prop('disabled', true);
		let oneAheadIs404 = false;
		let mainCompleted = false;

		function maybeHideButton() {
			if (oneAheadIs404 && mainCompleted) $btn.hide();
		}

		$.get(urlOneAhead).fail(function(xhr) {
			if (xhr.status === 404) {
				oneAheadIs404 = true;
				maybeHideButton();
			}
		});

		$.get(url).done(function(html) {
			const $loaded = $(html);
			const $items = $loaded.find('#news-list .news-list').children();
			if (!$items.length) {
				$btn.hide();
			} else {
				$items.addClass('news-item-load');
				$newsList.append($items);
				fadeInItems($items);
				nextPageNumber++;
			}
			mainCompleted = true;
			maybeHideButton();
			$btn.removeClass('is-loading').prop('disabled', false);
		}).fail(function(xhr) {
			$btn.removeClass('is-loading').prop('disabled', false);
			if (xhr.status === 404) $btn.hide();
		});
	});
}

// ========================================
// スクロール・ハッシュ
// ========================================

// ハッシュがあればその位置へスクロール
function scrollToHash() {
	if (!location.hash) return;
	const target = $(location.hash);
	if (!target.length) return;
	let adjustHeight = $(window).width() <= BREAKPOINTS.TABLET ? 71 : 0;
	window.scrollTo(0, target.offset().top - adjustHeight);
}

var SEARCH_CAL_WAIT_TIMEOUT = 8000;
// #searchCal の読み込み完了を待ってから scrollToHash を実行
function runScrollToHashWhenReady() {
	if (!location.hash) return;
	function doScroll() {
		requestAnimationFrame(function() {
			requestAnimationFrame(scrollToHash);
		});
	}
	const searchCal = document.getElementById('searchCal');
	if (!searchCal || searchCal.children.length > 0) {
		doScroll();
		return;
	}
	const timeout = setTimeout(doScroll, SEARCH_CAL_WAIT_TIMEOUT);
	const observer = new MutationObserver(function() {
		if (searchCal.children.length > 0) {
			observer.disconnect();
			clearTimeout(timeout);
			doScroll();
		}
	});
	observer.observe(searchCal, { childList: true, subtree: true });
}

// ========================================
// イベント登録・エントリポイント
// ========================================

// 画面サイズごとの処理
$(window).on('load resize', function() {
	deviceSizeFunc({
		sp: handleSmartphoneView,
		tablet: function() {},
		pc: function() {},
		overSp: handleOverSmartphoneView
	});
});

// アンカーリンクのスムーズスクロール
$('a[href^="#"]').on('click', function() {
	const href = $(this).attr('href');
	const target = $(href == '#' || href == '' ? 'html' : href);
	const adjustHeight = $(window).width() <= BREAKPOINTS.TABLET ? 71 : 0;
	$('html, body').animate(
		{ scrollTop: target.offset().top - adjustHeight },
		SCROLL_SPEED,
		SCROLL_EASING
	);
	return false;
});

// ページ読み込み完了時：ハッシュスクロール・ローダー・キービジュアル
$(window).on('load', function() {
	runScrollToHashWhenReady();

	const $loader = $('#loader');
	const $loaderLogo = $loader.find('.loader-logo');
	if (!$loader.length || !$loaderLogo.length) {
		initKeySlider();
		return;
	}
	$loaderLogo
		.css('opacity', 0)
		.delay(100)
		.animate({ opacity: 1 }, 1200)
		.delay(700)
		.animate({ opacity: 0 }, 1200, function() {
			initKeySlider();
			$loader.animate({ opacity: 0 }, 600, function() {
				$loader.remove();
			});
		});
});

// DOM ready：共通初期化
$(document).ready(function() {
	const systemInfo = getSystemInfo();
	if (systemInfo.browser) $('body').addClass(systemInfo.browser);
	if (systemInfo.os) $('body').addClass(systemInfo.os);

	initMenu();
	initImageSlider();
	initScrollFadeIn();
	initNewsLoadMore();
	initGnaviScrollSpy();

	// 客室エリア：名前エリアクリックでプランエリアを開閉
	$('.top-rooms-name-area').on('click', function() {
		$(this).next('.top-rooms-plan-area').slideToggle();
		$(this).find('.icon-arrow').toggleClass('rooms-open');
	});
});
